const Fetch = {
  post: function (url, data) {
    return fetch(url + '?authenticityToken=' + AUTHENTICITY_TOKEN, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify(data)
    }).then(function (response) {
      return Promise.all([response, response.json()])
    })
      .then(function (promises) {
        const response = promises[0];
        const json = promises[1];
        if (response.ok) return json;
        throw json;
      });

  },

  get: function (url) {
    return fetch(url, {credentials: 'same-origin'})
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return response
        }
        else {
          var error = new Error(response.statusText)
          error.response = response
          throw error
        }
      })
      .then(function (response) {

        return Promise.all([response, response.json()])
      })
      .then(function (promises) {
        const response = promises[0];
        const json = promises[1];
        if (response.ok) return json;
        throw json;
      });
  }
}
